// extracted by mini-css-extract-plugin
module.exports = {"sideLeft":"z_b8","sideRight":"z_b9","main":"z_cb"};